import { render, staticRenderFns } from "./feichun.vue?vue&type=template&id=239702e2&scoped=true"
import script from "./feichun.vue?vue&type=script&lang=js"
export * from "./feichun.vue?vue&type=script&lang=js"
import style0 from "./feichun.vue?vue&type=style&index=0&id=239702e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239702e2",
  null
  
)

export default component.exports